var map = {
	"./en": 298,
	"./en-GB": 308,
	"./en-GB.js": 308,
	"./en-IE": 309,
	"./en-IE.js": 309,
	"./en-US": 307,
	"./en-US.js": 307,
	"./en.js": 298
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 456;
module.exports = webpackAsyncContext;